document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.ch-menu-toggle');
  const drawerClose = document.querySelector('.ch-drawer-close');
  const drawerOverlay = document.querySelector('.ch-drawer-overlay');
  const drawer = document.querySelector('.ch-drawer');
  const navLinksWithSubmenu = document.querySelectorAll('.ch-nav-link.has-submenu');

  // Toggle Drawer
  function toggleDrawer() {
    drawer.classList.toggle('active');
    drawerOverlay.classList.toggle('active');
    document.body.classList.toggle('overflow-hidden');
  }

  if (menuToggle) menuToggle.addEventListener('click', toggleDrawer);
  if (drawerClose) drawerClose.addEventListener('click', toggleDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', toggleDrawer);

  // Accordion Logic for Submenus (Supports multiple levels)
  const accordionTriggers = document.querySelectorAll('.ch-nav-link.has-submenu, .ch-submenu-link.has-grandmenu');
  
  accordionTriggers.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const parentItem = this.parentElement;
      parentItem.classList.toggle('open');
    });
  });

  const cartTriggers = document.querySelectorAll('[data-ch-cart-trigger]');
  cartTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      // If the theme has a specific cart drawer click handler, trigger it
      const existingCartTrigger = document.querySelector('.m-cart-icon-bubble, [data-cart-drawer-trigger]');
      if (existingCartTrigger) {
        existingCartTrigger.click();
      }
    });
  });

  // Sticky Header Scroll Logic
  const headerWrapper = document.querySelector('.custom-header');
  const topBar = document.querySelector('.ch-top-bar');
  
  if (headerWrapper) {
    window.addEventListener('scroll', function() {
      const scrollY = window.scrollY;
      const threshold = topBar ? topBar.offsetHeight : 0;
      
      if (scrollY > threshold) {
        headerWrapper.classList.add('ch-sticky-active');
      } else {
        headerWrapper.classList.remove('ch-sticky-active');
      }
    });
  }

});
